import { fileShareSortBy } from '@wix/bi-logger-wixlabs-ugc/v2';

export const biFileShareWidgetSortBy = (props: any) => {
  const {
    instance_id,
    app_id,
    logger,
    visitor_id,
    comp_id,
    button_description,
    is_first,
  } = props;
  logger?.report(
    fileShareSortBy({
      instance_id,
      app_id,
      visitor_id,
      comp_id,
      button_description,
      is_first,
    }),
  );
};
